export default function Price({ current, old }) {
  const hasOld = Number(old) > Number(current);

  return (
    <div className="price">
      <strong>${Number(current || 0).toFixed(2)}</strong>
      {hasOld ? <span>${Number(old).toFixed(2)}</span> : null}
    </div>
  );
}
